module.exports = __webpack_public_path__ + "static/img/hero-war-bg.817b7d47.png";